import React, {useContext, useEffect, useState} from "react";
import {
  Layout,
  Row,
  Col,
  Table,
  Form,
  Button,
  Input,
  Select,
  Modal,
  Popover,
} from "antd";
import { CloseOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditFormEvaluacionCriteriosModel from "./EditFormEvaluacionCriteriosModel";
import "./modal.scss";
import { openNotification } from "../../../utils/Notifactions";
import axios from "axios";
import apiJurados from "../../../api/Jurados/api-jurados";
import { useMaestras } from "../../../hooks/useMaestras";
import {TemplateContext} from "../../../utils/template_context";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";

export default function EvaluacionCriteriosModel(props: any) {
  const { editValue, setEditValue, setEditValueList, datosActuales, setDatosActuales, editValueList } = props;
  const { Content } = Layout;
  const { Option } = Select;

  const context = useContext(TemplateContext);
  const fixedLeft: any = context.device === "md" ? "left" : false;
  const fixedRight: any = context.device === "lg" ? "right" : false;

  const [evaluationData, setEvaluationData] = useState<any>([]);
  const [evaluationFormData, setEvaluationFormData] = useState<any>({
    idconvocatorias: 1,
    nombre: "",
    descripcion: "",
    porcentaje: "",
  });

  const [editForm, setEditForm] = useState<any>(false);
  const [editFormData, setEditFormData] = useState<any>({});

  const { obtenerCriterios, criterios } = useMaestras()

  const columnsEdit: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 30,
      dataIndex: "idconvocatorias",
      key: "idconvocatorias",
      fixed: fixedLeft,
    },
    {
      title: <span className="as_tbl_hd">Criterio</span>,
      width: 100,
      dataIndex: "nombre",
      key: "nombre",
      fixed: fixedLeft,
      render: (datos) => {
        if (!datos) return null;
        if (datos.length > 27) return (
          <Popover content={datos} title="Criterio">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 30)}...`}</span>
          </Popover>
        );
        return datos;
      },
    },
    {
      title: <span className="as_tbl_hd">Descripción</span>,
      width: 100,
      dataIndex: "descripcion",
      key: "descripcion",
      fixed: fixedLeft,
    },
    {
      title: <span className="as_tbl_hd">Puntaje evaluación</span>,
      width: 100,
      dataIndex: "porcentaje",
      key: "porcentaje",
      fixed: fixedLeft,
      align: "center"
    },
    {
      title: () => (
        <p className="text-center">
          <span className="as_tbl_hd">Acciones</span>
        </p>
      ),
      width: 60,
      fixed: fixedRight,
      render: (datos: any, datos2: any, index: any) => (
          <p className="text-center">
            <button type="button" onClick={() => (setEditForm(true), setEditFormData(datos2))}>
              <EditOutlined />
            </button>
            {"  "}
            <button type="button" className="text-danger" onClick={() => onDelete(index, datos2)}>
              <DeleteOutlined />
            </button>
          </p>
      ),
    },
  ];
  const [formErrors, setFormErrors] = useState<any>();

  useEffect(() => {
    handelEditValueArray();
    obtenerCriterios();
  }, [props]);

  function onDelete(params: any, item: any) {
    const array = [...evaluationData];
    array.splice(params, 1);
    setEvaluationData(array);
  }

  function handelEditValueArray() {
    console.log("editValue: fff", editValue);
    const arrIndexs = editValue.findIndex((item: any) => !item.arrayData);

    if (arrIndexs) {
      setEvaluationData([]);
    }
  }

  function formValidation() {
    // 
    let formErrors: any = {};
    let formIsValid = true;

    if (!evaluationFormData.nombre) {
      formIsValid = false;
      formErrors["nombre"] = true;
    }
    if (!evaluationFormData.descripcion) {
      formIsValid = false;
      formErrors["descripcion"] = true;
    }
    if (!evaluationFormData.porcentaje) {
      formIsValid = false;
      formErrors["porcentaje"] = true;
    }

    if (!formIsValid) {
      return openNotification({
        titulo: "Error",
        descripcion: "Faltan campos por rellenar",
        placement: "bottomRight",
      });
    }

    setFormErrors(formErrors);
    return formIsValid;
  }
  function handelFormSubmit() {
    

    let existeCriterio = evaluationData.find((x: any) => x.nombre === evaluationFormData.nombre);
    if (existeCriterio) {
      return openNotification({
        titulo: "Error",
        descripcion: "Ya se asignó ese criterio",
        placement: "bottomRight",
      });
    }

    let count = 0;
    evaluationData.map((data: any) => {
      count = count + parseFloat(data.porcentaje);
    });

    count = count + parseFloat(evaluationFormData.porcentaje);

    console.log(count, "este es el conteo");

    // TEMP: tope de 100 puntos desactivado para pruebas desde localhost. Restaurar `count > 100 ||`.
    if (parseFloat(evaluationFormData.porcentaje) === 0) {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor verifique el puntaje de la evaluación, no superar 100 puntos",
        placement: "bottomRight",
      });
    }
    if (formValidation()) {
      let arrData = evaluationData;
      setEvaluationData([...arrData, evaluationFormData]);

      setEvaluationFormData({
        idconvocatorias: evaluationFormData.idconvocatorias + 1,
        nombre: "",
        descripcion: "",
        porcentaje: "",
      });
    }
  }
  let indexJurado = 0;
  let indexTabla = 0;
  const [loading, setLoading] = useState(false);

  const handelListDataSubmit: any = async () => {
    setLoading(true)
    let count = 0;
    evaluationData.forEach((cri: any) => {

      count += Number(cri.porcentaje);
    });

    // TEMP: validación de mínimo 100 puntos para guardar desactivada para pruebas desde localhost. Restaurar el bloque completo.
    // if (count < 100) {
    //   return openNotification({
    //     titulo: "Error",
    //     descripcion: "Por favor agregue más criterios, hasta sumar 100 puntos",
    //     placement: "bottomRight",
    //   });
    // }

    let arr: any = [];
    let proyectosAsignados: any = localStorage.proyectosAsignados
    proyectosAsignados = JSON.parse(proyectosAsignados);

    console.log( 'editValue', editValue )
    console.log( proyectosAsignados, 'estos son los proyectos' )
    console.log( 'evaluationData', evaluationData )

    const token = localStorage.getItem('token');
    for (const jurado of editValue) { // Iteramos sobre cada jurado
      console.log('jurado', jurado);
      for (const proyecto of proyectosAsignados) { // Iteramos sobre cada proyecto asignado
        console.log('proyecto', proyecto);
        for (const criterio of evaluationData) { // Iteramos sobre cada criterio de evaluación
          const { nombre, descripcion, porcentaje } = criterio;
          let payload = {
            nombre,
            descripcion,
            porcentaje,
            jury_id: jurado.id_jurado,
            postulacion_id: proyecto.id_postulacion
          };
          await axios.post(`${process.env.REACT_APP_SERVER_JURA2}criterios/crearCriterio/${jurado.id_jurado}`, payload, {
            headers: {
              "Authorization": token
            }
          });
          console.log(`✅ Criterio creado para Jurado ${jurado.id_jurado} en Postulación ${proyecto.id_postulacion}`);
        }
      }
    }

    let datosActualesNew: any = [...datosActuales];
    let editValueListNew: any = [...editValueList];
    editValue.map((data: any) => {
      console.log(data);
      datosActualesNew = datosActualesNew.filter((x: any) => x.id_jurado !== data.id_jurado);
      datosActuales.map((data2: any) => {
        if (data.id_jurado === data2.id_jurado) {
          editValueListNew = [...editValueListNew, data2];
        }
      })
    })
    setEditValueList(editValueListNew);
    setDatosActuales(datosActualesNew);
    setEditValue(arr);
    setEvaluationData([]);
    setLoading(false)
    props.setIsModalVisible(false);

  }

  const guardarCriterioTabla: any = async () => {
    const token = localStorage.getItem('token')
    if (evaluationData[indexTabla]) {
      evaluationData[indexTabla].jury_id = editValue[indexJurado].id_jurado;
      let proyectosAsignados: any = localStorage.proyectosAsignados
      proyectosAsignados = JSON.parse(proyectosAsignados);
      console.log(proyectosAsignados, 'estos son los proyectos')
      console.log(evaluationData[indexTabla], 'ES ESTO LO QUE SE ESTA GUARDANDO')
      proyectosAsignados.forEach(async (p: any) => {
        let payload = evaluationData[indexTabla];
        payload.postulacion_id = p.id_postulacion;
        console.log(payload)
        await axios.post(`${process.env.REACT_APP_SERVER_JURA2}criterios/crearCriterio/${editValue[indexJurado].id_jurado}`, evaluationData[indexTabla], {
          headers: {
            "Authorization": token
          }
        });
      });

      console.log(indexTabla, 'este es el index')
      indexTabla = indexTabla + 1;
      return guardarCriterioTabla();
    }

    indexJurado = indexJurado + 1;
    return handelListDataSubmit();
  }

  async function onEdit(upData: any) {

    
    
    if (upData.descripcion == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta la descripción",
        placement: "bottomRight",
      });
    }

    if (upData.nombre == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta el nombre",
        placement: "bottomRight",
      });
    }

    if (upData.porcentaje == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta el porcentaje",
        placement: "bottomRight",
      });
    }

    let arr = evaluationData.filter((x: any) => x.idconvocatorias !== upData.idconvocatorias);

    let existeYa = arr.find((x: any) => x.nombre === upData.nombre)

    if (existeYa) {
      return openNotification({
        titulo: "Error",
        descripcion: "Ya existe ese criterio",
        placement: "bottomRight",
      });
    }

    let criterioSin = evaluationData.filter((x: any) => x.nombre !== upData.nombre);


    let suma = 0;
    if(criterioSin.length !== 0 ){
      criterioSin.forEach((x: any) => {
        suma += Number(x.porcentaje)
      });
      if (Number(upData.porcentaje) > suma) {
        return openNotification({
          titulo: "Error",
          descripcion: "Por favor verifique el puntaje de la evaluación, no superar 100 puntos",
          placement: "bottomRight",
        });
      }
    }


    let evaluationDataNew = evaluationData.map((data: any) => {
      if (data.idconvocatorias === upData.idconvocatorias) {
        return {
          ...data,
          descripcion: upData.descripcion,
          nombre: upData.nombre,
          porcentaje: upData.porcentaje,
        };
      }
      return data;
    });
    setEvaluationData(evaluationDataNew)

    await apiJurados.actualizarCriterioJurado(upData);
    return setEditForm(false);
  }

  const cancelar = () => {
    setEvaluationData([])
    props.setIsModalVisible(false)
  }

  return (
    <div style={{ background: "hsla(89, 43%, 51%, 0.0)" }}>
      {editForm ? (
        <Modal
          className="transparent"
          visible={editForm}
          footer={false}
          onCancel={() => setEditForm(false)}
          width={1000}
          style={{ background: "hsla(89, 43%, 51%, 0.0)" }}
        >
          <EditFormEvaluacionCriteriosModel
            setEditForm={setEditForm}
            editFormData={editFormData}
            setEditFormData={setEditFormData}
            onEdit={onEdit}
          />
        </Modal>
      ) : (
        <div style={{ background: "hsla(89, 43%, 51%, 0.0)" }}>
          {/*  {editForm ?
                     <Modal className="eval_pro_model" visible={editForm} footer={false} width={1000} closable={false} >
                         <EditFormEvaluacionCriteriosModel closable={false} setEditForm={setEditForm} editFormData={editFormData} setEditFormData={setEditFormData} onEdit={onEdit} />
                     </Modal>
                     : */}
          <div style={{ margin: 0, background: "white", padding: "20px", borderRadius: "15px" }}>
            <Content className="mdl_header_containt">
              <Row
                className="tbl_md_heading_box"
                style={{
                  borderBottom: "1px solid #D7DBDD ",
                  paddingBottom: "6px",
                  marginBottom: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Col span={10} className="text-right">
                  <h3 className="asgevl_mdl_form_head">Criterios de evaluación </h3>
                </Col>

                <Col span={10} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button type="button" className="mdl_close_btn" onClick={() => props.setIsModalVisible(false)}>
                    <CloseOutlined />
                  </button>
                </Col>
              </Row>
            </Content>
            <Content className="asgevl__top_mdl_box" style={{ background: "white", borderRadius: "15px" }}>
              <Content className="">
                <Form>
                  <Row>
                    <Col span={24}>
                      <Content className="p-1">
                        <span className="form--lable asgevl_form_lable">Criterio de evaluación</span>

                        <Select
                          showSearch
                          optionFilterProp="children"
                          suffixIcon={<FlechaSelect />}
                          placeholder="Seleccionar..."
                          style={{ width: "100%" }}
                          onChange={(e: any) =>
                            setEvaluationFormData({
                              ...evaluationFormData,
                              nombre: e,
                            })
                          }
                          className="eval--selct"
                          value={evaluationFormData.nombre}
                          id={`${!evaluationFormData.nombre && formErrors?.nombre ? "error" : ""}`}
                        >
                          {criterios.map(({ id, nombre }: any) =>
                            <Option key={id} value={nombre}>{nombre}</Option>
                          )}
                        </Select>
                      </Content>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 5, display: "flex", justifyContent: "space-between" }}>
                    <Col span={11}>
                      <Content className="p-1">
                        <span className="form--lable asgevl_form_lable">Descripción</span>
                        <Input.TextArea
                          maxLength={1000}
                          showCount
                          className="eval--textarea"
                          onChange={(e: any) => {

                            setEvaluationFormData({
                              ...evaluationFormData,
                              descripcion: e.target.value,
                            })
                          }}
                          value={evaluationFormData.descripcion}
                          id={`${!evaluationFormData.descripcion && formErrors?.descripcion ? "error" : ""}`}
                        />
                        {console.log("formErrors: ", formErrors)}
                      </Content>
                    </Col>
                    <Col span={11}>
                      <Content className="p-1">
                        <span className="form--lable asgevl_form_lable">Puntaje de evaluación</span>
                        <Input
                          maxLength={3}
                          min={0}
                          max={100}
                          // type="number"
                          onChange={(e: any) => {
                            // 
                            e.target.value = e.target.value.replace(/\D/, "")
                            setEvaluationFormData({
                              ...evaluationFormData,
                              porcentaje: e.target.value,
                            })
                          }}
                          className="eval-input evl_cat_input"
                          value={evaluationFormData.porcentaje}
                          id={`${!evaluationFormData.porcentaje && formErrors?.porcentaje ? "error" : ""}`}
                        />
                      </Content>
                    </Col>
                  </Row>
                </Form>
              </Content>
              <Content className="mb-2">
                <Row className="">
                  <Col span={24} className="form--btm-btn-box" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      onClick={() => handelFormSubmit()}
                      className="button-blanco-radius"
                      style={{ margin: 14, cursor: "pointer" }}
                    >
                      Agregar
                    </Button>
                  </Col>
                </Row>
              </Content>
            </Content>
          </div>
          <div className="id" style={{ borderRadius: "15px" }}>
            <Content style={{ marginTop: 20, background: "white", padding: "20px", borderRadius: "15px" }}>
              <Content className="asgevl_table_box">
                <Content className="evalpro_table_head asgevl_tbl_head">
                  <Row className="tbl_md_heading_box">
                    <Col span={16}>
                      <span className="tbl__head eval_tbl_head">Lista de criterios a evaluar !!</span>
                    </Col>
                    <Col span={8}>
                      <p className="table--total table--total-mdl text-right">
                        Total : <span className="text-orance">{evaluationData.length}</span>
                      </p>
                    </Col>
                  </Row>
                </Content>

                <Content className="mb-1">
                  {
                    //@ts-ignore
                    <Table
                      columns={columnsEdit}
                      dataSource={evaluationData}
                      scroll={{ x: 800, y: 300 }}
                      size="small"
                      //rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                      pagination={false}
                      rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                    />
                  }
                </Content>

                {/* <Content className="mb-2" style={{ display: "flex", justifyContent: "flex-end" }}> */}
                  <Row justify="end" align="middle" gutter={[24,24]}>
                    <Col>
                      <button
                        type="button"
                        onClick={cancelar}
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                      >
                        Cancelar
                      </button>
                    </Col>
                    <Col>
                      {evaluationData && evaluationData.length > 0 ? (
                        <Button className="button-azul-radius" type="primary" loading={loading} onClick={() => handelListDataSubmit()}>
                          Asignar Criterios
                        </Button>
                      ) : (
                        <Button className="button-azul-radius" type="primary">
                          Asignar Criterios
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Content>
              </Content>
            {/* </Content> */}
          </div>

          {/*   } */}
        </div>
      )}
    </div>
  );
}
